import React from 'react';
import type { VoteValue } from './common/types';
import { useDisableResolvedIssueVoting } from './services';
import { VoteToggleBase, IssueVotersBase } from './ui';

interface Props {
	onFieldUpdated?: (value: VoteValue) => void;
}

export const VoteToggle = ({ onFieldUpdated }: Props) => {
	const disableVotingProps = useDisableResolvedIssueVoting();
	return <VoteToggleBase disableVotingProps={disableVotingProps} onFieldUpdated={onFieldUpdated} />;
};

export const IssueVoters = ({ onFieldUpdated }: Props) => {
	const disableVotingProps = useDisableResolvedIssueVoting();
	return (
		<IssueVotersBase disableVotingProps={disableVotingProps} onFieldUpdated={onFieldUpdated} />
	);
};
